/**
 * Accordion JavaScript singleton module
 */

var Accordion = (function($) {

  function initAccordion() {

    $('.accordion__heading').click(function(){
        $(this).toggleClass('accordion__heading--opened').toggleClass('accordion__heading--closed');
        $(this).next('.accordion__panel').toggleClass('accordion__panel--opened').toggleClass('accordion__panel--closed');
    });    

  }

  function initCheckbox(){
    if ($("input[type=checkbox]").is(":checked")) {
      //alert("Checked");
      }

  }

  function init() {

    // return early if no corresponding module present
    if (!$('.accordion').length) {
      return;
      
    }

    initAccordion();
    initCheckbox();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Accordion.init);
